import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { ObjectEditor, cleanContent } from "./FieldEditor";
import { api, formatApiError } from "../../lib/api";

export const SECTION_LABELS = {
  hero: "Hero principal", marquee: "Marquesina",
  principio: "Nuestro principio", soluciones: "¿Qué vendemos?", pasos: "¿Cómo funciona?",
  celular: "Tu celular", dinero: "Nuestras soluciones (catálogo)", membresia: "Membresía Dorada",
  filosofia: "Nuestra filosofía", manifiesto: "Manifiesto", testimonios: "Testimonios (títulos)", faq: "Preguntas frecuentes (títulos)",
  cta: "Llamado a la acción", registro: "Formulario de registro", footer: "Pie de página", media: "Imágenes y videos",
  compensacion: "Porcentajes de comisión", paises: "Países disponibles", legal: "Legal", contacto: "Datos de contacto",
};

export const ContentPanel = ({ keys, content, setContent, title, description }) => {
  const [active, setActive] = useState(keys[0]);
  const [saving, setSaving] = useState(false);
  const current = keys.includes(active) ? active : keys[0];

  const save = async () => {
    setSaving(true);
    try {
      const data = cleanContent(content);
      await api.put("/admin/content", { data });
      setContent(data);
      toast.success("Cambios guardados y publicados");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="content-panel">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-3xl font-semibold tracking-tight">{title}</h2>
          {description && <p className="mt-1 text-sm text-ink/70">{description}</p>}
        </div>
        <button onClick={save} disabled={saving} className="btn-ink !px-6 !py-3 !text-sm disabled:opacity-60" data-testid="content-save-btn">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Guardar cambios
        </button>
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-[240px_1fr]">
        {keys.length > 1 && (
          <div className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
            {keys.map((k) => (
              <button
                key={k}
                onClick={() => setActive(k)}
                data-testid={`content-section-${k}`}
                className={`shrink-0 rounded-xl px-4 py-2.5 text-left text-sm font-medium transition-colors ${
                  current === k ? "bg-ink text-white" : "bg-white text-ink/80 hover:bg-ink/5"
                }`}
              >
                {SECTION_LABELS[k] || k}
              </button>
            ))}
          </div>
        )}
        <div className={`rounded-2xl border border-ink/10 bg-white/70 p-5 sm:p-7 ${keys.length > 1 ? "" : "lg:col-span-2"}`}>
          <h3 className="mb-5 font-display text-xl font-semibold">{SECTION_LABELS[current] || current}</h3>
          <ObjectEditor
            value={content[current] || {}}
            onChange={(v) => setContent({ ...content, [current]: v })}
            prefix={`content-${current}`}
          />
        </div>
      </div>
    </div>
  );
};
